<div class="CeParameterList-wrap">
    <ng-content></ng-content>
</div>
